module.exports = __webpack_public_path__ + "img/bg-search-container.2addeb6.png";